import { Box } from '@intech/web-ui';
import React from 'react';
import { FichaFinanceiraEntidade } from '@entidades';

interface IProps {
  Detalhes: Array<FichaFinanceiraEntidade>;
}

export const ExtratoDetalhado: React.FC<IProps> = ({
  Detalhes
}) => {

  function ToMoney(Valor: number | undefined | null, FractionDigits = -1) {
    var options: any = {
      minimumFractionDigits: 2
    }
    if (FractionDigits > -1) {
      options = {
        minimumFractionDigits: FractionDigits,
        maximumFractionDigits: FractionDigits
      }
    }
    if (Valor === null || Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', options)
    );
  }

  function renderContribuicoes() {
    if (Detalhes.length > 0) {
      const detalhes = Detalhes.map((detalhe: FichaFinanceiraEntidade, index: number) => {

        return (
          <tr key={index}>
            <td style={{ "textAlign": "center" }}>
              {detalhe.MES_REF + "/" + detalhe.ANO_REF}
            </td>
            <td>
              {detalhe.DS_TIPO_CONTRIBUICAO}<br />
            </td>
            <td style={{ "textAlign": "right" }}>
              R$ {ToMoney(detalhe.CONTRIB_PARTICIPANTE! + detalhe.CONTRIB_EMPRESA!, 2)}<br />
            </td>
            <td style={{ "textAlign": "right" }}>
              R$ {ToMoney(detalhe.SRC, 2)}<br />
            </td>
          </tr>
        );
      });
      return (
        <Box title={"Extrato Detalhado"}>
          <div className={"table-responsive"}>
            <table className={"table table-striped table-sm"}>
              <thead>
                <tr>
                  <th style={{ "textAlign": "center" }}>
                    {"Mês/Ano "}
                  </th>
                  <th>
                    {"Tipo Contribuição"}
                  </th>
                  <th style={{ "textAlign": "right" }}>
                    {"Valor Contribuição"}
                  </th>
                  <th style={{ "textAlign": "right" }}>
                    {"Salário Real de Contribuição"}
                  </th>
                </tr>
              </thead>

              <tbody>
                {detalhes}
              </tbody>
            </table>
          </div>
        </Box>
      );
    }
    return null;
  }

  return renderContribuicoes();
}